module.exports = __webpack_public_path__ + "img/classes_calendar.6fe75813.png";